import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import ScrollToTop from '@/components/ScrollToTop';
import WhatsAppButton from '@/components/ui/WhatsAppButton';
import Home from '@/pages/Home';
import PrivacyPolicy from '@/pages/legal/PrivacyPolicy';
import Terms from '@/pages/legal/Terms';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />
        <Route path="/terminos" element={<Terms />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <WhatsAppButton />
      <Toaster />
    </Router>
  );
}

export default App;